import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { FaUsers } from "react-icons/fa";
import { MdOutlineCardTravel } from "react-icons/md";
import DashboardCard from "../../Components/Cards/DashboardCard";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import ThemeChart from "../../Components/ThemeChart";
import { chartData, chartOptions } from "../../constants";
import { useGetDashboardQuery } from "../../Data/services/dashboardApi";
import { ROUTES } from "./constants";
import { useEffect, useState } from "react";

export default function Dashboard({ setPage }) {
  const [updatedData, setupdatedData] = useState([]);
  const { data, isLoading, isFetching } = useGetDashboardQuery();

  let bg1 = "rgb(52, 131, 75)";
  let bg2 = "rgba(91, 173, 114, 1)";
  let iconColor = "rgba(66, 196, 223, 1)";
  const handleViewLiveMatches = () => {
    setPage(ROUTES.LIVE_MATCHES);
  };

  const handleViewTournament = () => {
    setPage(ROUTES.TOURNAMENTS);
  };

  const cardData = [
    {
      icon: <MdOutlineCardTravel color={iconColor} />,
      number: isLoading ? (
        <LoadingButton />
      ) : (
        data?.data?.dashboardStats?.total_completed_trips
      ),
      text: "Completed Trips",
    },
    {
      icon: <MdOutlineCardTravel color={iconColor} />,
      number: isLoading ? (
        <LoadingButton />
      ) : (
        data?.data?.dashboardStats?.total_ongoing_trips
      ),
      text: "Ongoing Trips",
    },
    {
      icon: <FaUsers color={iconColor} />,
      number: isLoading ? (
        <LoadingButton />
      ) : (
        data?.data?.dashboardStats?.total_users
      ),
      text: "Users",
    },
  ];

  const getMonthName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "short" });
  };

  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth = data?.data?.dashboardGraphData?.totalTripGraph?.find(
        (item) => getMonthName(item.month) === month
      );
      updatedData.push(dataForMonth ? dataForMonth.total_orders : 0);
    });
    setupdatedData(updatedData);
  }, [data]);

  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div>
      </div>
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        {cardData.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={4} md={4} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedData}
              chartOptions={chartOptions}
              loading={isLoading}
            />
            {/* <MonthDropdown
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            /> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}
